import { render, staticRenderFns } from "./jobs-school.vue?vue&type=template&id=444f198c&scoped=true&"
import script from "./jobs-school.vue?vue&type=script&lang=js&"
export * from "./jobs-school.vue?vue&type=script&lang=js&"
import style0 from "./jobs-school.vue?vue&type=style&index=0&id=444f198c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444f198c",
  null
  
)

export default component.exports